import {factory} from '../../../utils/apiThunkFactory'

export const updateUserDeviceState = factory.put('mediaControls/updateUserDeviceState', '/api/users/updateUserDevice')